<template>
	<div class="light-dashboard">
		<toolbar style="border-bottom: 0;">
			<dashboard-tasks-panel
				v-show="totalReviewItemsCount > 0"
				class="tasks-panel"
				v-on:totalItemsCountChange="setTotalReviewItemsCount">
			</dashboard-tasks-panel>
		</toolbar>

		<clock-in-timer v-if="$store.clockedIn"></clock-in-timer>
		<router-link v-else to="/punch-clock" class="light-punch-clock-btn">
			<i class="fa fa-clock"></i>
			<div class="light-punch-clock-btn-text">
				<div class="light-punch-clock-btn-title">CLOCK IN</div>
				<div class="light-punch-clock-btn-subtitle">Let's get started</div>
			</div>
		</router-link>

		<my-schedule-today></my-schedule-today>

		<router-link to="/service/new/details/details" class="light-emergency-wo-btn">
			<div class="light-emergency-wo-icon">
				<i class="fa fa-bolt"></i>
			</div>
			<div class="light-emergency-wo-text">
				<div class="light-emergency-wo-eyebrow">Need to Create Work?</div>
				<div class="light-emergency-wo-title">Emergency Work Order</div>
				<div class="light-emergency-wo-subtitle">Create a new service work order fast.</div>
			</div>
			<i class="fa fa-chevron-right light-emergency-wo-chevron"></i>
		</router-link>
	</div>
</template>

<script type="text/javascript">
import MyScheduleToday from "@/components/widgets/MyScheduleToday"
import Toolbar from "@/layout_fragments/Toolbar"
import DashboardTasksPanel from "@/components/super_components/DashboardTasksPanel"
import ClockInTimer from "@/components/ClockInTimer"

export default {
	name: "LightDashboard",
	components: {
		MyScheduleToday,
		DashboardTasksPanel,
		Toolbar,
		ClockInTimer
	},
	data() {
		return {
			totalReviewItemsCount: 0
		}
	},
	methods: {
		setTotalReviewItemsCount(value) {
			this.totalReviewItemsCount = value
		}
	}
}
</script>

<style scoped>
.light-dashboard {
	max-width: 800px;
	margin: auto;
}

.light-punch-clock-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--brand-primary-color);
	color: #fff;
	border-radius: 16px;
	padding: 1.25rem 1.5rem;
	margin-bottom: 1.25rem;
	text-decoration: none;
	width: 100%;
}

.light-punch-clock-btn:hover {
	color: #fff;
	text-decoration: none;
	opacity: 0.92;
}

.light-punch-clock-btn .fa-clock {
	font-size: 2.5rem;
	margin-right: 1rem;
}

.light-punch-clock-btn-text {
	display: flex;
	flex-direction: column;
	line-height: 1.2;
}

.light-punch-clock-btn-title {
	font-weight: 700;
	font-size: 1.5rem;
	letter-spacing: 0.02em;
}

.light-punch-clock-btn-subtitle {
	font-size: 0.95rem;
	font-weight: 400;
}

.light-emergency-wo-btn {
	display: flex;
	align-items: center;
	background-color: #fcf8f8;
	color: var(--brand-primary-color);
	border-radius: 16px;
	padding: 1rem 1.25rem;
	margin-top: 1.25rem;
	text-decoration: none;
	width: 100%;
}

.light-emergency-wo-btn:hover {
	color: var(--brand-primary-color);
	text-decoration: none;
	opacity: 0.92;
}

.light-emergency-wo-icon {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: rgba(220, 53, 69, 0.15);
	color: #dc3545;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
	font-size: 1.35rem;
}

.light-emergency-wo-text {
	flex-grow: 1;
	min-width: 0;
	line-height: 1.25;
}

.light-emergency-wo-eyebrow {
	font-size: 0.8rem;
	font-weight: 700;
}

.light-emergency-wo-title {
	font-size: 1.15rem;
	font-weight: 700;
}

.light-emergency-wo-subtitle {
	font-size: 0.85rem;
	font-weight: 400;
}

.light-emergency-wo-chevron {
	flex-shrink: 0;
	margin-left: 0.75rem;
	font-size: 1.1rem;
}

@media (max-width: 550px) {
	.light-dashboard >>> .widget-card {
		margin-left: 0;
		margin-right: 0;
	}
}
</style>
